import React from 'react';
import { dispatch } from 'nike-re-framejs';

import { Button } from 'nike-ui/src/components/button/Button';
import i18n from '@i18n';
import { fireGAEvent } from '@/analytics';
import ReloadLightIcon from '@/icons/ReloadLightIcon';
import { registerPopup } from '@/ui/popupRegistrar';
import StornoDialog from './StornoDialog';
import PopupNg from '@/ui/PopupNg';
import { ticketStornoOpen } from '@/mytickets/storno/handlers';

registerPopup('ticket/storno', () => <StornoDialog />);

function Storno({ hash, ticketNumber, branchId }) {
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');
        fireGAEvent('Detail tiketu', 'Storno');
        dispatch(ticketStornoOpen(hash, ticketNumber, branchId));
        PopupNg.dispatcher.close('betbook/ticketDetailPopup');
    }
    return (
        <Button
            className="blue"
            dataAtid="ticket-detail-storno"
            icon={ReloadLightIcon}
            label={i18n('commons.button.stornovat')}
            onClick={onClick}
        />
    );
}

export default Storno;
